import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RegisterEmailParams } from "src/types/register-email";

@Injectable({
  providedIn: "root",
})
export class AuthProvider {
  constructor(private httpClient: HttpClient) {}

  verify(): Observable<any> {
    return this.httpClient.get("/api/auth/verify");
  }

  login(email: string, password: string): Observable<any> {
    return this.httpClient.post("/api/auth/login/email", {
      email,
      password,
    });
  }

  logout(): Observable<any> {
    return this.httpClient.post("/api/auth/logout", null);
  }

  validatePasswordResetToken(id: string): Observable<any> {
    return this.httpClient.post(`/api/auth/password/validate/${id}`, null);
  }

  sendPasswordReset(email: string): Observable<any> {
    return this.httpClient.post("/api/auth/password/send", {
      email,
    });
  }

  resetPassword(token: string, password: string): Observable<any> {
    return this.httpClient.post("/api/auth/password/reset", {
      token,
      password,
    });
  }

  registerEmail(params: RegisterEmailParams): Observable<any> {
    return this.httpClient.post("/api/auth/register/email", params);
  }

  verifyEmail(token: string): Observable<any> {
    return this.httpClient.post("/api/auth/verify/email", {
      token,
    });
  }

  validateTwoFactorToken(id: string): Observable<any> {
    return this.httpClient.get(`/api/auth/twofactor/${id}`);
  }

  validateTwoFactorCode(id: string, code: string): Observable<any> {
    return this.httpClient.post(`/api/auth/twofactor/${id}`, {
      code,
    });
  }
}
